module.exports = __webpack_public_path__ + "img/q-7-2@2x.a3aa69ae.png";